module.exports = __webpack_public_path__ + "static/media/img_socialmedia-02Snapchat.bb10f90f.png";